import {useRuntimeConfig} from "nuxt/app";
import { RoutingDefinitions } from "@generator/types/RoutingDefinitions";

export const getPortalTypeDefinitionClient = (): RoutingDefinitions => {
	const runtimeConfig = useRuntimeConfig();
	const portalTypeStr = (runtimeConfig.public.portalType as string) || 'master';

	switch (portalTypeStr.toLowerCase()) {
	case 'bachelor':
	case 'phd':
	case 'short':
		return RoutingDefinitions.PORTAL_ROUTE
	case 'distance_learning':
		return RoutingDefinitions.ATTENDANCE_ROUTE;
	default:
		return RoutingDefinitions.PORTAL_OMNISEARCH_ROUTE;
	}

};
